import { Switch } from '@mui/material';

/**
 * Toggle control for boolean settings.
 * @param {object} props
 * @param {boolean} props.value
 * @param {function} props.onChange - fn(bool)
 */
export default function SettingsToggle({ value, onChange }) {
    return (
        <Switch
            checked={!!value}
            onChange={(e) => onChange(e.target.checked)}
            size="small"
            sx={{
                '& .MuiSwitch-switchBase.Mui-checked': { color: '#4cceac' },
                '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': { bgcolor: '#4cceac' },
                '& .MuiSwitch-track': { bgcolor: '#294766' },
            }}
        />
    );
}
